import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { CountryService } from "../../services/CountryService";
import { Divider } from "primereact/divider";
import LawRegulationsTable from "../Common/LawRegulationsTable";
import { AddPageHeader } from "../Common/Utils";

const LawRegulations = () => {
  const [laws, setLaws] = useState([]);
  const countryService = new CountryService();

  useEffect(() => {
    countryService.getLaws().then((data) => setLaws(data));
  }, []);

  return (
    <div className="reduce-width">
      {AddPageHeader("International organizations")}
      <Divider align="center">
        <h1>International organizations</h1>
      </Divider>
      <div className="privacy-terms">
        This page features laws, regulations, and policies on consular affairs
        issued by international organizations such as the United Nations, the
        Association of Southeast Asian Nations, and the European Union. Are you
        representing an international organization? Interested in updating the
        list? Please feel free to{" "}
        <Link
          to="/contact"
          style={{
            color: "black",
            fontWeight: "bold",
          }}
        >
          contact
        </Link>{" "}
        the Center.
      </div>
      <LawRegulationsTable data={laws} searchEnabled longDescription />
    </div>
  );
};

export default LawRegulations;
